import IcBell from './IcBell'

export default IcBell
